import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { TableNotFoundHint } from 'components/TableNotFoundHint'

import { ProtocolsType } from '../../../../types/Protocols.types'
import { ModalDeleteProtocols } from '../../ModalDeleteProtocols/ModalDeleteProtocols'
import { ProtocolsDropdown } from './ProtocolsDropdown'

import { deleteProtocols } from 'store/Protocols/Protocols.actions'
import { useTranslation } from 'react-i18next'

import * as S from './styled'

export type ProtocolsTableProps = {
  rows: ProtocolsType[]
}

export function ProtocolsTable({ rows = [] }: ProtocolsTableProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [_deleteProtocols, _setDeleteProtocols] = useState({} as ProtocolsType)

  function onExit() {
    _setDeleteProtocols({} as ProtocolsType)
  }

  function onRemoveProtocols() {
    dispatch(deleteProtocols(_deleteProtocols.id))
    _setDeleteProtocols({} as ProtocolsType)
  }

  return (
    <S.Wrapper data-testid="ProtocolsTable">
      {Object.keys(_deleteProtocols).length ? (
        <ModalDeleteProtocols
          protocolsCode={_deleteProtocols.code}
          protocolsName={_deleteProtocols.name}
          onExit={onExit}
          onRemove={onRemoveProtocols}
        />
      ) : null}
      <S.Table>
        <tbody>
          <S.Line id="header">
            <S.Header>{t('tables:protocolsName')}</S.Header>
            <S.Header>{t('tables:protocolsCode')}</S.Header>
            <S.Header>{t('tables:protocolsDescription')}</S.Header>
            <S.Header>{t('common:actions')}</S.Header>
          </S.Line>
          {rows.length > 0 &&
            rows.map(each => (
              <S.Line id="values" key={each.id}>
                <S.Column>{each.name}</S.Column>
                <S.Column className="right">{each.code}</S.Column>
                <S.Column>{each.description}</S.Column>

                <S.Column id="actions-column">
                  <ProtocolsDropdown
                    id={each.id}
                    protocolsName={each.name}
                    setDeleteProtocols={() => _setDeleteProtocols(each)}
                  />
                </S.Column>
              </S.Line>
            ))}
        </tbody>
      </S.Table>
      {!rows.length && <TableNotFoundHint to="/protocolos/novo" />}
    </S.Wrapper>
  )
}
